import { BUSINESS_HOURS, type BusinessHours } from "@/config/contact";

/**
 * ¿Estamos dentro del horario de atención, en hora de Panamá?
 *
 * Panamá no aplica DST, pero el cálculo se ancla a la zona (no al reloj local
 * del dispositivo) para que un reloj mal configurado no afirme una disponibilidad
 * falsa. `now` y `hours` se inyectan para poder probar los bordes sin mockear el reloj.
 *
 * Devuelve `null` si el navegador no puede resolver la hora en la zona: la UI debe
 * degradar sin afirmar un estado.
 */
export const isWithinBusinessHours = (
  now: Date = new Date(),
  hours: BusinessHours = BUSINESS_HOURS
): boolean | null => {
  try {
    const hourPart = new Intl.DateTimeFormat("en-US", {
      timeZone: hours.timeZone,
      hour: "numeric",
      hour12: false,
    })
      .formatToParts(now)
      .find((part) => part.type === "hour");

    if (!hourPart) return null;

    const parsed = Number(hourPart.value);
    if (!Number.isFinite(parsed)) return null;

    // h23 puede devolver "24" para medianoche según el motor del navegador.
    const hour = parsed === 24 ? 0 : parsed;

    return hour >= hours.startHour && hour < hours.endHour;
  } catch {
    return null;
  }
};